import { useRef, useState } from 'react';

// import RightArrowIcon from '../../../Icon/RightArrowIcon';
import Link from '../../../Link';
import { Underline } from '../../../Link/types';
import { ITEMS_TO_DISPLAY, MenuItem } from '../../types';

import styles from './ShortList.module.css';
import { ShortListComponentProps } from './types';

const ShortList = ({ shortList, mainUrl }: ShortListComponentProps) => {
  // const timeoutRef = useRef<any>(0);
  const shortListRef = useRef<HTMLUListElement>(null);
  // const isShortListOpened = useRef<boolean>(false);
  const [shortListHeight, setShortListHeight] = useState<string>('0px');

  // useEffect(() => {
  //   return () => clearTimeout(timeoutRef.current as NodeJS.Timeout);
  // }, []);

  const handleMenuOpen = () => {
    // if (!timeoutRef.current) {
    //   isShortListOpened.current = !isShortListOpened.current;
    //   if (shortListRef.current) {
    //     if (isShortListOpened.current) {
    //       setShortListHeight(`${shortListRef?.current?.scrollHeight}px`);
    //       timeoutRef.current = setTimeout(() => {
    //         setShortListHeight('auto');
    //         clearTimeout(timeoutRef.current);
    //         timeoutRef.current = null;
    //       }, 300);
    //     } else {
    //       setShortListHeight(`${shortListRef?.current?.scrollHeight}px`);
    //       timeoutRef.current = setTimeout(() => {
    //         setShortListHeight('0px');
    //         clearTimeout(timeoutRef.current);
    //         timeoutRef.current = null;
    //       }, 0);
    //     }
    //   }
    // }
  };

  return shortList?.sub && shortList?.sub?.length > 0 ? (
    <>
      <Link data-testid={'short-list-main-link'} href={shortList.url} underline={Underline.none} classes={`${styles.shortListMainLink} mainSubElement`}>
        {shortList.name}
      </Link>
      {/* <p className={styles.shortListTitle} onTouchStart={handleMenuOpen}>
        {shortList.name}
        <span
          className={clsx(styles.shortListArrowIcon, {
            [styles.shortListArrowIconActive]: isShortListOpened.current,
          })}
        >
          <RightArrowIcon />
        </span>
      </p> */}
      {shortList.sub && (
        <ul
          className={`${styles.shortListItems} ${styles.shortListItemsAnimation}`}
          ref={shortListRef}
          style={{ height: shortListHeight }}
        >
          {shortList.sub.slice(0, ITEMS_TO_DISPLAY).map(({ parentId, name, url }: MenuItem) => (
            <li data-testid={'short-list-item-url'} key={`${parentId}-${name}`} className={`${styles.shortListItem} childSubElement`}>
              <Link href={url} classes={styles.shortListItemUrl}>
                {name}
              </Link>
            </li>
          ))}
          {shortList?.sub.length > ITEMS_TO_DISPLAY && (
            <li className={`${styles.shortListItem} viewAllElements`}>
              <Link data-testid={'short-list-view-all-url'} href={shortList.url} classes={`${styles.shortListItemUrl} ${styles.shortListViewMore}`}>
                {`View All ${shortList.name}`}
              </Link>
            </li>
          )}
        </ul>
      )}
    </>
  ) : (
    <Link data-testid={`short-list-${shortList.name}-url`} href={shortList.url} classes={`${styles.shortListUrl} mainSubElement`}>
      {shortList.name}
    </Link>
  );
};

export default ShortList;
